import React from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import { useHistory } from 'react-router-dom';
import Center from '@components/common/alignment/Center';
import LargeBlueButton from '@components/common/button/LargeBlueButton';

const SignOut: React.FC = () => {
  const history = useHistory();

  const signOut = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        history.push('/signin');
      });
  };

  return (
    <Center>
      <LargeBlueButton text='SIGN OUT' onClick={signOut}></LargeBlueButton>
    </Center>
  );
};

export default SignOut;
